var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlloyWheels32 = function SvgAlloyWheels32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 30c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14Z",
    stroke: "currentColor",
    strokeWidth: 2.029,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26c5.523 0 10-4.477 10-10S21.523 6 16 6 6 10.477 6 16s4.477 10 10 10Z",
    stroke: "currentColor",
    strokeWidth: 2.029,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
    stroke: "currentColor",
    strokeWidth: 2.029,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 7.04a3.634 3.634 0 0 1-1.23 2.13 3.517 3.517 0 0 1-2.286.83 3.519 3.519 0 0 1-2.277-.856A3.636 3.636 0 0 1 12.5 7M7.869 21.479a3.634 3.634 0 0 1 2.13-1.23 3.518 3.518 0 0 1 2.395.424 3.519 3.519 0 0 1 1.544 1.88 3.635 3.635 0 0 1-.027 2.46m10.631-3.547a3.634 3.634 0 0 0-2.13-1.23 3.518 3.518 0 0 0-2.395.424 3.519 3.519 0 0 0-1.544 1.88A3.636 3.636 0 0 0 18.5 25M7.85 10.249a3.634 3.634 0 0 1 1.739 1.74c.356.76.43 1.618.21 2.422a3.519 3.519 0 0 1-1.416 1.978A3.636 3.636 0 0 1 6 17m17.86-6.751a3.634 3.634 0 0 0-1.74 1.74 3.517 3.517 0 0 0-.21 2.422c.22.805.722 1.505 1.416 1.978.695.473 1.538.69 2.383.611",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
};
export default SvgAlloyWheels32;